import Vue from 'vue';
import App from '@/App.vue';

import AppConfig from '@/AppConfig';
import Brand from '@/modules/brand/brand';

// Service Worker
/**
 * Service workers and PWA have been disabled
 * TODO: Evaluate later if the new server side
 * approach can support
 */
// import '@/registerServiceWorker';

// Routerscopy
import router from '@/router';

// Store
import store from '@/store';

//Modules
import URLParams from '@/modules/url_params/url_params';

// Filters
import { DateFormat, FromNow } from './fitlers/date-format';
Vue.filter('dateFormat', DateFormat);
Vue.filter('fromNow', FromNow);

import { Ordinal } from './fitlers/ordinal';
Vue.filter('ordinal', Ordinal);

// Components
import IMSPage from '@/components/page/page.vue';
Vue.component('ims-page', IMSPage);

import IMSDriverBall from '@/components/driver-ball/driver-ball.vue';
Vue.component('ims-driver-ball', IMSDriverBall);

import IMSToolbar from '@/components/toolbar/toolbar.vue';
Vue.component('ims-toolbar', IMSToolbar);

import IMSIcon from '@/components/md-icon/md-icon.vue';
Vue.component('ims-icon', IMSIcon);

import IMSMenuButton from '@/components/menu-button/menu-button.vue';
Vue.component('ims-menu-button', IMSMenuButton);

import IMSBackButton from '@/components/back-button/back-button.vue';
Vue.component('ims-back-button', IMSBackButton);

import IMSButton from '@/components/button/button.vue';
Vue.component('ims-button', IMSButton);

import IMSAvatar from '@/components/avatar/avatar.vue';
Vue.component('ims-avatar', IMSAvatar);

import IMSBadge from '@/components/badge/badge.vue';
Vue.component('ims-badge', IMSBadge);

import IMSRaceSelector from '@/components/race-selector/race-selector.vue';
Vue.component('ims-race-selector', IMSRaceSelector);

import IMSItem from '@/components/list-item/list-item.vue';
Vue.component('ims-item', IMSItem);

import IMSInput from '@/components/input/input.vue';
Vue.component('ims-input', IMSInput);

import IMSCoin from '@/components/coin/coin.vue';
Vue.component('ims-coin', IMSCoin);

import IMSCountdown from '@/components/countdown/countdown.vue';
Vue.component('ims-countdown', IMSCountdown);

import IMSModal from '@/components/modal/modal.vue';
Vue.component('ims-modal', IMSModal);

import IMSFastestLap from '@/components/input/fastest-lap-input.vue';
Vue.component('ims-fastest-lap-input', IMSFastestLap);

import IMSSpinner from '@/components/spinner/spinner.vue';
Vue.component('ims-spinner', IMSSpinner);

import IMSTip from '@/components/tip/tip.vue';
Vue.component('ims-tip', IMSTip);

import IMSBox from '@/components/box/box.vue';
Vue.component('ims-box', IMSBox);

import IMSMeter from '@/components/meter/meter.vue';
Vue.component('ims-meter', IMSMeter);

import IMSStandings from '@/containers/standings/standings.vue';
Vue.component('ims-standings', IMSStandings);

// Make Config available everywhere.

Vue.prototype.$AppConfig = AppConfig;
Vue.prototype.$Brand = Brand;

// Import Global Stylesheet;
import './scss/main.scss';

// What is this?
Vue.config.productionTip = false;

/**
 * Check for a passed bearer Code
 */
let params: URLParams = new URLParams(document.location.href);
// If we have a bear code - or clear-bearer - do this
if (params.get('bearer')) {
  // Save to session storage.
  sessionStorage.setItem('bearer', params.get('bearer'));
  document.location.href = '/';
} else if (params.get('clear-bearer')) {
  sessionStorage.clear();
  document.location.href = '/';
}
// Trying to get iOS oAuth to work with social
// declare const document: any;
// let iOS = !!navigator.platform && /i(Phone|Pad|Pod)/.test(navigator.platform);
// if (iOS) {
//   document
//     .querySelector('link[rel="manifest"]')
//     .setAttribute('rel', 'no-on-ios');
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
